import { Dimensions } from 'react-native'

export default class STYLES {
    static WIDTH = Dimensions.get('window').width
    static HEIGHT = Dimensions.get('window').height

    static BACKGROUND_COLOR = 'rgba(255, 255, 255, 1)'
    static BACKDROP_COLOR = 'rgba(0, 0, 0, 0.65)'

    static LIGHT_GREEN = 'rgba(255, 0, 155, 1.0)'
    static DARK_GREEN = 'rgba(252, 30, 146, 1.0)'
    static CARD_BACKGROUND_COLOR = 'rgba(255, 255, 255, 1)'
    static ERROR_CARD_BACKGROUND_COLOR = 'rgba(249, 78, 90, .15)'
    static ERROR_CARD_BORDER_COLOR = 'rgba(249, 78, 90, 1)'

    static PRIMARY_TEXT_COLOR = 'rgba(158, 168, 186, 1)'
    static PRIMARY_TEXT_ALPHA_COLOR = 'rgba(158, 168, 186, .15)'
    static SECONDARY_TEXT_COLOR = 'rgba(102, 102, 102, 1)'

    static TRANSACTIONS_DATE = 'rgba(64, 64, 64, 1)'
    static TRANSACTIONS_DATA = 'rgba(128, 128, 128, 1)'

    static SHADOW_COLOR = 'rgba(30, 63, 86, 0.1)'

    static TRANS_NEW_COLOR = 'rgba(25, 235, 51, 1)'
    static TRANS_RECURRING_COLOR = 'rgba(120, 92, 251, 1)'
}



// WEBPACK FOOTER //
// ./src/constants/styles.js